module.exports = __webpack_public_path__ + "img/xianshangshouquan.b5837996.png";